import React from 'react';
import { Payload } from 'recharts/types/component/DefaultLegendContent';

type CustomPayload<T> = {
  legendLabels: Partial<Record<keyof T, string>>;
  payload: Payload[];
};

export function BaseLegend<T>(props: CustomPayload<T>) {
  const { payload, legendLabels } = props;
  return (
    <ul className="deck-chart-legends">
      {payload.map((entry) => {
        const label = legendLabels[entry.value as keyof T];
        return (
          <li key={entry.value as string} className="deck-chart-legends__item">
            <div
              className="deck-chart-legends__item__bar"
              style={{
                backgroundColor: entry.color,
              }}
            />
            <span>{label}</span>
          </li>
        );
      })}
    </ul>
  );
}
